<template>
  <div class="relative flex space-x-4 py-2 text-sm font-medium text-gray-300 transition-opacity duration-100">
    <input
      :id="name"
      ref="input"
      :name="name"
      type="checkbox"
      :value="modelValue"
      :checked="modelValue"
      :required="required"
      class="h-5 w-5 rounded border-2 border-gray-300 bg-transparent text-blue-500 focus:border-gray-300 focus:outline-none focus:ring-blue-300 focus:ring-offset-black disabled:cursor-wait"
      :class="wasInvalidated ? 'invalid:ring-2 invalid:ring-red-400' : ''"
      :disabled="state === FormState.LOADING"
      @input="onChange"
      @invalid="wasInvalidated = true" />

    <label
      :for="name"
      class="checkbox">
      {{ copy }}
      <a
        v-if="link"
        :href="link.href"
        target="_blank">
        {{ link.label }}
      </a>
      {{ required ? '*' : '' }}
    </label>

    <span
      v-if="errorMessage && wasInvalidated && !isValid"
      class="absolute bottom-0 left-5 -mb-3.5 text-xs text-red-400"
      >{{ errorMessage }}</span
    >
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from '#imports'

  import { FormState } from '~/constants/form'

  type CheckboxProps = {
    state: FormState
    name: string
    copy: string
    link?: {
      label: string
      href: string
    }
    required?: boolean
    errorMessage?: string
    modelValue: boolean | null
  }

  type CheckboxEmits = {
    (event: 'update:modelValue', value: boolean): void
  }

  defineProps<CheckboxProps>()

  const emit = defineEmits<CheckboxEmits>()

  // eslint-disable-next-line vue/prefer-use-template-ref
  const input = ref<HTMLInputElement | null>(null)
  const wasInvalidated = ref(false)
  const isValid = ref<boolean | null>(null)

  function onChange(event: Event) {
    emit('update:modelValue', (event.target as HTMLInputElement).checked)
    wasInvalidated.value = false
    isValid.value = input.value.validity.valid
  }

  onMounted(() => {
    isValid.value = input.value.validity.valid
  })
</script>

<style scoped>
  .checkbox:deep(a) {
    @apply font-bold underline;
  }
</style>
